module.exports = __webpack_public_path__ + "static/img/pc_img_logo_forgot_password_paycools.4155bd22.png";